import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./Navigation.css";

import history from "../../../history";

class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.links = [
            { label: "Wnioski", icon: "clipboard list", destination: "/requests/hr/pending", 
                access: { admin: 0, supervisor: -1, hrUser: true, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/requests"], deny: [] }},

            { label: "Wnioski", icon: "clipboard list", destination: "/requests/pending", 
                access: { admin: 0, supervisor: 2, hrUser: false, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/requests"], deny: [] }},

            { label: "Wnioski", icon: "clipboard list", destination: "/requests/pending", 
                access: { admin: 0, supervisor: 1, hrUser: false, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/requests"], deny: [] }},

            { label: "Wnioski", icon: "clipboard list", destination: "/requests/new", 
                access: { admin: 0, supervisor: 0, hrUser: false, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/requests"], deny: [] }},

            { label: "Czas pracy", icon: "clock", destination: "/working-time/employees?month=current", 
                access: { admin: 0, supervisor: 2, hrUser: null, noIntern: true, noExternal: false, coordinator: null },
                prefixes: { allow: ["/working-time"], deny: [] }},

            { label: "Czas pracy", icon: "clock", destination: "/working-time/my?month=current", 
                access: { admin: 0, supervisor: 1, hrUser: null, noIntern: true, noExternal: false, coordinator: null },
                prefixes: { allow: ["/working-time"], deny: [] }},

            { label: "Czas pracy", icon: "clock", destination: "/working-time/external?month=current", 
                access: { admin: 0, supervisor: 0, hrUser: null, noIntern: true, noExternal: false, coordinator: true },
                prefixes: { allow: ["/working-time"], deny: [] }},    

            { label: "Czas pracy", icon: "clock", destination: "/working-time/my?month=current", 
                access: { admin: 0, supervisor: 0, hrUser: null, noIntern: true, noExternal: false, coordinator: false },
                prefixes: { allow: ["/working-time"], deny: [] }},

            { label: "Nieobecności", icon: "calendar times", destination: "/absence", 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/absence"], deny: ["/absence/reasons"] }},
            
            { label: "Wynagrodzenia", icon: "money bill alternate", destination: "/paychecks", 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/paychecks"], deny: [] }},

            { label: "Szkolenia", icon: "file alternate", destination: process.env.REACT_APP_TRAINING_ORIGIN, external: true, 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: true, noExternal: false, coordinator: null },
                prefixes: { allow: [], deny: [] }},

            { label: "Stołówka", icon: "utensils", destination: "/meal-reservations/my", 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: false, noExternal: false, coordinator: null },
                prefixes: { allow: ["/meal-reservations", "/menus", "/meal-orders"], deny: [] }},

            { label: "Formularze", icon: "file pdf", destination: "/forms", 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: false, noExternal: false, coordinator: null },
                prefixes: { allow: ["/forms"], deny: [] }},

            { label: "Ustawienia panelu", icon: "cog", destination: "/structure", 
                access: { admin: 1, supervisor: -1, hrUser: null, noIntern: true, noExternal: true, coordinator: null },
                prefixes: { allow: ["/structure", "/absence/reasons", "/users", "/settings"], deny: [] }},

            { label: "Konto", icon: "user", destination: "/account", 
                access: { admin: 0, supervisor: -1, hrUser: null, noIntern: false, noExternal: false, coordinator: null },
                prefixes: { allow: ["/account"], deny: [] } }
        ];
    }

    componentDidMount() {
        this.unlisten = history.listen(location => {
            if (location.pathname === "/") this.redirectToHome();
        });
    }

    componentDidUpdate() {
        this.redirectToHome();
    }

    componentWillUnmount() {
        this.unlisten();
    }

    getSupervisorValue = () => {
        let output = this.props.currentUser.isSupervisor ? 1 : 0;
        if (output) {
            if (this.props.currentUser.subUnits.find(u => u.ranking === 1)) output = 2;
        }
        return output;
    }

    checkPrefixes = (prefixes, pathname) => {
        let allow = 0;
        prefixes.allow.forEach(prefix => allow += pathname.startsWith(prefix))
        let deny = 0;
        prefixes.deny.forEach(prefix => deny += pathname.startsWith(prefix))
        return allow > 0 && deny === 0;
    }

    redirectToHome = () => {
        let home = "/";
        this.links.forEach(link => home = (
            this.props.currentUser.admin >= link.access.admin &&
            this.getSupervisorValue() >= link.access.supervisor &&
            (this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID || !link.access.hrUser) &&
            (this.props.currentUser.intern === 0 || !link.access.noIntern) &&
            (this.props.currentUser.externalOuID === null || !link.access.noExternal) &&
            (this.props.currentUser.isCoordinator || !link.access.coordinator) &&
            home === "/") ? link.destination : home);
        if (home !== "/") this.props.onLoad(home);
    }

    renderLinks = () => this.links.map((link, index) => {
        if (
            this.props.currentUser.admin >= link.access.admin &&
            (link.access.supervisor === -1 || (link.access.supervisor !== -1 && link.access.supervisor === this.getSupervisorValue())) &&
            (link.access.hrUser === null || (link.access.hrUser !== null && (this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID) === link.access.hrUser)) &&
            (this.props.currentUser.intern === 0 || !link.access.noIntern) &&
            (this.props.currentUser.externalOuID === null || !link.access.noExternal) &&
            (link.access.coordinator === null || (link.access.coordinator !== null && this.props.currentUser.isCoordinator === link.access.coordinator))
        ) {
            return (
                React.createElement(link.external ? "a" : Link,
                    link.external ? { href: link.destination, className: "item", key: index } : { to: link.destination, className: `${this.checkPrefixes(link.prefixes, history.location.pathname) ? "active " : ""}item`, key: index }, "", (
                        <h2 className="ui icon header">
                            <i className={`${link.icon} icon`}></i>
                            <p className="content">{link.label}</p>
                        </h2> 
                    )
                )
            );
        }
        else return null;
    });

    render() {
        return (
            <React.Fragment>
                <div className="navigation-component ui huge divided selection list">
                    {this.renderLinks()}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({ currentUser: state.user.current });

export default connect(mapStateToProps)(Navigation);